import React from 'react';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag';
import { FeatureFlag } from 'src/types/FeatureFlag';
import { LegacyContact } from './LegacyContact';
import { BalanceContact } from './BalanceContact';

export function Contact(): JSX.Element {
  const { value: isBalanceUiEnabled } = useFeatureFlag(
    FeatureFlag.ENABLE_BALANCE_UI
  );

  return isBalanceUiEnabled ? <BalanceContact /> : <LegacyContact />;
}
